import { render, staticRenderFns } from "./PurchaseNew.vue?vue&type=template&id=5a3b084e&scoped=true"
import script from "./PurchaseNew.vue?vue&type=script&lang=ts"
export * from "./PurchaseNew.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseNew.vue?vue&type=style&index=0&id=5a3b084e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b084e",
  null
  
)

export default component.exports